import {useState, useContext,useEffect} from "react";
import { useParams } from "react-router-dom";
import {Dialog, TextField} from "@material-ui/core"
import { DesktopTimePicker  } from '@mui/x-date-pickers/DesktopTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import styles from './PayrollModals.module.css'
import { clearPayrollProcess } from "../../../context/PayrollProcess/Actions";
import PayrollProcessContext from "../../../context/PayrollProcess/PayrollProcessContext";
import { useMutation } from "@apollo/client";
import { GET_PAYROLL_DISPERSION_2, 
         CREACION_PROGRAMACION_DISPERSION 
        } from "../../../Querys/querys";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import moment from 'moment';
import { AdminContext } from "../../../context/AdminContext/AdminContext";
import { isBefore, differenceInMinutes, startOfMinute  } from 'date-fns';
import { WarningAlert } from "../../../alerts/WarningAlert";
import useGeolocation from "../../../hooks/useGeolocation";
import { ErrorAlert } from "../../../alerts/errorAlert";


const ProgramarDispersar = (props:any) =>{
  const { id:idPayroll } = useParams<{ id: string }>();
  const {adminState} = useContext(AdminContext)
  const {totalesDispersar, totales, seleccionados, idRegistro} = props
  const {state, dispatch} = useContext(PayrollProcessContext)
  const [activo, setactivo] = useState(false)
  const [selectedTime, setSelectedTime] = useState<Date>(new Date());
  const [initialTime, setInitialTime] = useState<Date>(new Date());
  const [sendDispersionProg] = useMutation(CREACION_PROGRAMACION_DISPERSION,{
    refetchQueries:[
      {query: GET_PAYROLL_DISPERSION_2, variables:{getPayrollDispersionId: idRegistro}}
    ]
  })
  const [fechaProgramacion, setFechaProgramacion] = useState(moment().format("YYYY-MM-DD"));
  const [permission, setPermission] = useState(false)
  const { location,error } = useGeolocation()
  
  const combineDateAndTime = (date: string, time: any): Date | null => {
    if (!date || !time || !time['$d']) {
      return null;
    }
 
    const formattedDate = moment(date, 'YYYY-MM-DD');
  
    // Extraer horas y minutos de la cadena de tiempo
    const timeString = time['$d'];
    const timeObject = new Date(timeString);
    const hours = timeObject.getHours();
    const minutes = timeObject.getMinutes();
  
    const combinedDateTime = moment(formattedDate).set({
      hour: hours,
      minute: minutes,
      second: 0,  
    });  
    return combinedDateTime.toDate();
  };
  
  useEffect(() => {
     setInitialTime(selectedTime);
  }, []);

  useEffect(() => {
    handleCheckPermision()
  }, [])

    const handleCheckPermision = () => {
    navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      if (result.state === 'granted') {
        setPermission(true)
      } else if (result.state === 'prompt') {
        // Solicita el permiso de geolocalización al usuario
        navigator.geolocation.getCurrentPosition(
          () => setPermission(true),
          () => setPermission(false)
        );
        // console.log('Permiso de geolocalización solicitado')
      } else if (result.state === 'denied') {
        setPermission(false)
      }
    })
  }

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;    
    const today = new Date().toISOString().split('T')[0];    
    if (selectedDate >= today) {
      setFechaProgramacion(selectedDate);
    } else {      
      ErrorAlert({text:'Seleccionaste una fecha anterior a hoy'});
    }
  };

  const handleTimeChange = (newValue: any) => {
    const today = new Date().toISOString().split('T')[0]; 
    const validDate = new Date(fechaProgramacion);  
    if (!isNaN(validDate.getTime())) { 
      const selectedDateStr = validDate.toISOString().split('T')[0]; 
      if (selectedDateStr === today) {

        const newDate = startOfMinute(new Date(newValue)); 
        const selectedDate = initialTime instanceof Date
          ? startOfMinute(initialTime) 
          : startOfMinute(new Date(initialTime)); 
  
        if (isBefore(newDate, selectedDate)) {
          setSelectedTime(new Date());
          ErrorAlert({ text: 'La hora seleccionada no puede ser anterior a la hora inicial en la fecha actual' });
          return;
        }
      }  
      setSelectedTime(newValue);
    } else {
      console.log('La fecha de programación no es válida');
    }
  };
  
  const handleClose = () =>{
    props.reinicia()    
    setactivo(false)
    setFechaProgramacion(moment().format("YYYY-MM-DD"));
    setSelectedTime(new Date());
    clearPayrollProcess({}, dispatch)
  }

  const handleChange = (e: any) => {
    if (e.target.value === 'CONFIRMAR') {
      setactivo(true);
    } else {
      setactivo(false);
    }
  };

  const agregaSeleccionados = async() =>{

    if (permission) {
       if(location) {
        let Array:any = []
        seleccionados.map((lis:any)=>{
          Array.push({ id: parseInt(lis) })
        })

        const timeDifference = differenceInMinutes(selectedTime, initialTime);
        if (timeDifference === 0) {
          return ErrorAlert({text:'Por favor seleccione una hora de programación mayor a la actual.'});    
        }     

        const combinedDateTime = combineDateAndTime(fechaProgramacion, selectedTime);
        const combinedDateTimeMoment = moment(combinedDateTime);
        const combinedDateTimeString = combinedDateTimeMoment.local().format('YYYY-MM-DDTHH:mm:ss');  
        for(const lis of Array){
          const inputProg= {
            id: lis.id,
            FechaProgramacion: combinedDateTimeString,
            user: adminState?.Usuario,
            idPayroll:idPayroll,
            latitude: String(location.latitude),  
            longitude: String(location.longitude),
          }
          await sendDispersionProg({
            variables:{
                input: inputProg
              }
          })
        }
        SuccessfulAlert({text: "Registros programados con exito"})   
        handleClose()
          }else if (error) {
        ErrorAlert({ text: "Error al obtener la localizacion" });
        setactivo(false)
        handleClose()
        return;
      } 
    }else {
      WarningAlert({text: "Por favor, activa los permisos de geolocalización para dispersar."})
      setactivo(false)
      handleClose()
    }
  }


  return(
    <Dialog aria-labelledby='costumized-dialog-title' open={state.programarDispersar} fullWidth={false} maxWidth={"md"}>
      <div className={styles.contenedorPrincipal}>
      <div className={styles.contenedorCerrarModal}>
     </div>
      <div className={styles.contenedorPrincipal}>
          <div className={styles.fim_iconoPrincipal}>
            <div className={styles.fim_iconoComplemento}>
            </div>
          </div>
        </div>
        <div className={styles.tituloAtencion}>
          ¡Atenci&oacute;n!
        </div>
            <div className={styles.em_mensajePrtincipal}>
              Est&aacute;s por programar n&oacute;mina a {totalesDispersar}/{totales} colaboradores
            </div>

                <div className={styles.em_mensajePrtincipal}>
                    Fecha de programación
                </div>
                <div className={styles.pdd_contenedor}>
                    <TextField
                    type="date"
                    value={fechaProgramacion}
                    autoFocus={true}
                    name="date"
                    variant="outlined"
                    size="small"
                    onChange={handleDateChange}
                    InputProps={{
                        readOnly: false,
                    }}
                    />
            </div>

            
              <div className={styles.em_mensajePrtincipal}>
                    Hora programación
                </div>

              <div className={styles.pdd_contenedor}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopTimePicker  
                          onChange={handleTimeChange}
                          value={selectedTime}
                          renderInput={(params:any) => <TextField {...params}   
                          onKeyDown={(e) => e.preventDefault()}                  
                          variant="outlined"                          
                          size="small"/>}
                          />
                      </LocalizationProvider>
            </div>

            <div className={styles.em_mensajePrtincipal}>
            Escribe CONFIRMAR para continuar
          </div>

            <div>
              <input
                className={styles.input}
                type="text"
                onChange={(e) => handleChange(e)}
              />
          </div>
        <div className={styles.em_contenedorBotones}>
              <button
                className={styles.em_botonCancelar}
                onClick={()=> handleClose()}
              >
                Cancelar
              </button>
              {
              (activo === true ?
                  <button 
                    className={`${styles.botonesAtencion} ${styles.continuarAtencion}`}
                    onClick={()=> agregaSeleccionados()}
                  >
                    <div>
                      Confirmar
                    </div>
                  </button>
                  :
                  <button
                    className={`${styles.botonesAtencion} ${styles.continuarAtencionInactivo}`}
                  >
                    <div>
                      Confirmar
                    </div>
                  </button>
                )
            }
            </div>
      </div>
    </Dialog>
  )
}

export default ProgramarDispersar